import React from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import { Box, CircularProgress, Typography } from '@mui/material';

const PublicRoute = ({ children }) => {
  const { user, loading } = useAuth();

  // Mostrar spinner mientras se verifica la autenticación
  if (loading) {
    return (
      <Box
        sx={{
          minHeight: '100vh',
          display: 'flex',
          flexDirection: 'column',
          justifyContent: 'center',
          alignItems: 'center',
          backgroundImage: 'linear-gradient(135deg, #fcdcf4 0%, #c46494 50%, #602442 100%)',
          gap: 2
        }}
      >
        <CircularProgress 
          size={60} 
          sx={{ 
            color: 'white',
            '& .MuiCircularProgress-circle': {
              strokeLinecap: 'round',
            }
          }} 
        />
        <Typography 
          variant="h6" 
          sx={{ 
            color: 'white',
            fontWeight: 'bold',
            textShadow: '0 2px 4px rgba(0,0,0,0.3)'
          }}
        >
          Verificando autenticación...
        </Typography>
      </Box>
    );
  }

  // Si ya hay usuario autenticado, redirigir al admin
  if (user) {
    return <Navigate to="/admin" replace />;
  }

  // Si no hay usuario autenticado, mostrar el contenido público (login)
  return children;
};

export default PublicRoute;
